import { KeyboardShortcut } from './keyboard-shortcut';

class KeyboardShortcutBuilder {
  private useModifier = false;
  private useShift = false;
  mod(): this {
    this.useModifier = true;
    return this;
  }
  shift(): this {
    this.useShift = true;
    return this;
  }
  key(key: string): KeyboardShortcut {
    return new KeyboardShortcut({
      useShift: this.useShift,
      useModifier: this.useModifier,
      key,
    });
  }
}

export function useKeyboardShortcut() {
  function kbd(): KeyboardShortcutBuilder {
    return new KeyboardShortcutBuilder();
  }
  return { kbd };
}
